import { Suspense, lazy } from 'react';

import { DynamicBaseBreadcrumb, DynamicSiteGroupsBreadcrumb } from '../../modules/AppBreadcrumb';
import { Spinner } from '../components';
import { AppControllerType, AppRoutes } from '../interfaces/router';

const SiteGroupsListPage = lazy(() => import('../../pages/SiteGroups/SiteGroupsList.page'));
const SiteGroupsCreatePage = lazy(() => import('../../pages/SiteGroups/SiteGroupsCreate.page'));
const SiteGroupsEditPage = lazy(() => import('../../pages/SiteGroups/SiteGroupsEdit.page'));
const SiteGroupsPage = lazy(() => import('../../pages/SiteGroups/SiteGroups.page'));

export const SiteGroupsController: AppControllerType = {
  common: [
    {
      path: AppRoutes.SiteGroups + '/*',
      element: (
        <Suspense fallback={ <Spinner/> }>
          <SiteGroupsListPage/>
        </Suspense>
      ),
      breadcrumb: DynamicSiteGroupsBreadcrumb.DynamicSiteGroupsListBreadcrumb
    },
    {
      path: AppRoutes.SiteGroupsById + '/*',
      element: (
        <Suspense fallback={ <Spinner/> }>
          <SiteGroupsPage/>
        </Suspense>
      ),
      breadcrumb: DynamicSiteGroupsBreadcrumb.DynamicSiteGroupsByIdBreadcrumb
    }
  ],
  drawer: [
    {
      path: AppRoutes.SiteGroupsCreate,
      element: (
        <Suspense fallback={ <Spinner/> }>
          <SiteGroupsCreatePage/>
        </Suspense>
      ),
      breadcrumb: DynamicBaseBreadcrumb.DynamicBaseCreateBreadcrumb,
      props: {
        commonDrawerWidth: 480
      }
    },
    {
      path: AppRoutes.SiteGroupsByIdEdit,
      element: (
        <Suspense fallback={ <Spinner/> }>
          <SiteGroupsEditPage/>
        </Suspense>
      ),
      breadcrumb: DynamicBaseBreadcrumb.DynamicBaseEditBreadcrumb,
      props: {
        commonDrawerWidth: 480
      }
    }
  ]
};
